module.exports = "/images/negociamos.svg?b08d2d94bd88e7e65cd9b383b6cea970";